/*
 * Colour sibling swatches: hovering one shows that colour's name in the
 * "Color: <name>" label above, and restores the real one on the way out.
 *
 * Delegated on document so it covers swatches that arrive later — the quick
 * view fetches its content, and swaps it again when a swatch is clicked.
 */
(function () {
  if (window.cspsSwatchHoverBound) return;
  window.cspsSwatchHoverBound = true;

  const SWATCH = '[data-csps-color-name]';
  const LABEL = '.product__color-text-value';

  // Climb from the swatch until an ancestor holds a colour label. Product cards
  // have no label, so this returns null there and hovering just rings.
  function findLabel(swatch) {
    let el = swatch.closest('.csps') || swatch;
    el = el.parentElement;
    while (el && el !== document.body) {
      const label = el.querySelector(LABEL);
      if (label) return label;
      el = el.parentElement;
    }
    return null;
  }

  function closestSwatch(node) {
    return node && node.closest ? node.closest(SWATCH) : null;
  }

  document.addEventListener('mouseover', function (event) {
    const swatch = closestSwatch(event.target);
    if (!swatch) return;

    const label = findLabel(swatch);
    if (!label) return;

    // Remember the real colour once, so leaving always restores it even after
    // moving straight from one swatch to another.
    if (label.dataset.cspsOriginal === undefined) {
      label.dataset.cspsOriginal = label.textContent;
    }
    label.textContent = swatch.getAttribute('data-csps-color-name');
  });

  // The "+N" chip ends the first row. Shows up to max swatches, but never more
  // than fit on that row beside the chip, trimming until it does.
  //
  // Both kinds of list get this. Only the product page's also carries
  // data-csps-expandable, which is what lets the chip reveal the rest in
  // place; on a card the chip opens the product instead, so the fitting and
  // the expanding are separate attributes rather than one.
  const FIT_ROW = '.csps__list[data-csps-fit-row]';

  function fitFirstRow(list) {
    if (list.dataset.cspsExpanded) return;

    const chipItem = list.querySelector('.csps__item--overflow');
    if (!chipItem) return;

    // By class, not by [data-csps-expand]: a card's chip does not carry that
    // attribute, and looking for it there found nothing and left the count
    // standing at whatever Liquid had written.
    const button = chipItem.querySelector('.csps__overflow');
    const items = Array.prototype.filter.call(list.children, function (li) {
      return li !== chipItem;
    });
    const max = parseInt(list.dataset.cspsMax, 10) || items.length;

    // What the chip is counting is colours the visitor cannot see, which is
    // not the same as items this list is hiding. A card renders only max_items
    // of them, so counting its own children would say "+2" where eight colours
    // exist and three are shown. The real total comes down as an attribute.
    const total = parseInt(list.dataset.cspsTotal, 10) || items.length;

    let visible = Math.min(max, items.length);
    function apply() {
      items.forEach(function (li, i) {
        li.hidden = i >= visible;
      });
      const hiddenCount = total - visible;
      chipItem.hidden = hiddenCount <= 0;
      if (button) button.textContent = '+' + hiddenCount;
    }

    apply();

    // Not laid out yet (e.g. a closed quick view): leave it at max for now,
    // the resize observer fits it once it is shown.
    if (!items.length || !list.offsetWidth) return;

    // The chip is shorter than a swatch, so it has wrapped only once it starts
    // below the first swatch's bottom edge.
    const firstBottom = items[0].offsetTop + items[0].offsetHeight;
    while (visible > 1 && !chipItem.hidden && chipItem.offsetTop >= firstBottom) {
      visible -= 1;
      apply();
    }
  }

  const resizeObserver =
    'ResizeObserver' in window
      ? new ResizeObserver(function (entries) {
          entries.forEach(function (entry) {
            const list = entry.target;
            const width = Math.round(entry.contentRect.width);
            if (list._cspsWidth === width) return;
            list._cspsWidth = width;
            fitFirstRow(list);
          });
        })
      : null;

  function bindLists(root) {
    (root || document).querySelectorAll(FIT_ROW).forEach(function (list) {
      if (list._cspsBound) return;
      list._cspsBound = true;
      fitFirstRow(list);
      if (resizeObserver) resizeObserver.observe(list);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindLists();
    });
  } else {
    bindLists();
  }

  // The quick view swaps its content in after load.
  let bindQueued = false;
  new MutationObserver(function () {
    if (bindQueued) return;
    bindQueued = true;
    requestAnimationFrame(function () {
      bindQueued = false;
      bindLists();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (!resizeObserver) {
    window.addEventListener('resize', function () {
      document.querySelectorAll(FIT_ROW).forEach(fitFirstRow);
    });
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest ? event.target.closest('[data-csps-expand]') : null;
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const list = button.closest('.csps__list');
    if (!list) return;

    list.dataset.cspsExpanded = 'true';
    Array.prototype.forEach.call(list.children, function (li) {
      li.hidden = false;
    });

    const overflowItem = button.closest('.csps__item--overflow');
    if (overflowItem) overflowItem.remove();
  });

  document.addEventListener('mouseout', function (event) {
    const swatch = closestSwatch(event.target);
    if (!swatch) return;

    // Still inside the same swatch (moving over its image), or straight onto
    // another swatch, which will set its own name.
    const to = event.relatedTarget;
    if (to && swatch.contains(to)) return;
    if (closestSwatch(to)) return;

    const label = findLabel(swatch);
    if (!label || label.dataset.cspsOriginal === undefined) return;

    label.textContent = label.dataset.cspsOriginal;
    delete label.dataset.cspsOriginal;
  });
})();
